import { fetchAuthSession } from 'aws-amplify/auth'
import axios from 'axios';
import apiurl from "./apiweb.js"

// Endpoint de receptores para documentos DTE web (separado del POS).
// Antes "receptoresfacturasweb"; renombrado a "receptoresdteweb" porque los
// documentos web ya no son solo facturas.
const ENDPOINT = "receptoresdteweb";

const obj = {

    addReceptor: async (params) => {
        const token = (await fetchAuthSession()).tokens?.idToken?.toString();
        return axios.post(apiurl + ENDPOINT,
            {
                ...params
            }
            ,
            {
                headers: {
                    'content-type': 'application/json',
                    'Authorization': "Bearer " + token,
                },
                crossdomain: true
            });
    },
    getReceptores: async (filtros) => {
        const token = (await fetchAuthSession()).tokens?.idToken?.toString();
        const params = {};
        if (filtros.rutsv) params.rut = filtros.rutsv;
        if (filtros.rutExacto) params.rutExacto = filtros.rutExacto;
        if (filtros.razon_social) params.razon_social = filtros.razon_social;
        if (filtros.ciudad) params.ciudad = filtros.ciudad;
        if (filtros.comuna) params.comuna = filtros.comuna;
        if (filtros.page) params.page = filtros.page;
        if (filtros.limit) params.limit = filtros.limit;


        return axios.get(apiurl + ENDPOINT, {
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + token,
            },
            params,
            crossdomain: true,
        });
    },
    updateReceptor: async (params) => {
        const token = (await fetchAuthSession()).tokens?.idToken?.toString();
        return axios.put(apiurl + ENDPOINT,
            {
                ...params
            }
            ,
            {
                headers: {
                    'content-type': 'application/json',
                    'Authorization': "Bearer " + token,
                },
                crossdomain: true
            });
    },
    deleteReceptor: async (rut) => {
        const token = (await fetchAuthSession()).tokens?.idToken?.toString();
        return axios.delete(`${apiurl}${ENDPOINT}`, {
            params: {
                rut: rut
            },
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + token,
            },
            crossdomain: true
        });
    },
};

export default obj;
